import {
  Component,
  OnInit,
  ChangeDetectorRef,
  PLATFORM_ID,
  Inject,
  Optional,
  inject,
  DestroyRef,
  Input,
  signal,
} from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { FavoritesService } from "../../services/favorites.service";
import { ParamFilters } from "../../models/filtermodels/ParamFilters";
import { Item } from "../../models/hotels/Item";
import { OfferpackService } from "../../services/offerpack.service";
import { AuthGuardService } from "../../services/auth-guard.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AuthService } from "../../services/auth.service";
import { GlobalmenuService } from "../../services/globalmenu.service";
import { Customer } from "../../models/customers/Customer";
import { Price } from "../../models/hotels/Price";
import { Partner } from "../../models/partner/IPartner";
import { CruiseSearchParams } from "@app/models/filtermodels/CruiseSearchParams";
import { EncryptionService } from "@app/services/encyption.service";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { ChatService } from "@app/services/chat.service";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { PartnerloginComponent } from "../modals/partnerlogin/partnerlogin.component";
import { Menu } from "./Menu";
import { GoToFilter } from "../tools/GoToFilter";
import { MEDIA_TOKEN } from "tockens";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
export interface PathHistory {
  country: Item;
  region: Item;
  hotel: Item;
  flug: string;
  booking: Price;
}
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() defaultMenu: any;
  @Input() isBooking?: boolean = false;
  desktopTemplate: boolean = true;
  mobile: boolean = false;
  realparams: ParamFilters | CruiseSearchParams | any;
  isOpen: boolean = false;
  fixsetoultip: boolean = false;
  openSubmenu: boolean = false;
  showsearch: boolean = false;
  partner: Partner;
  curentMenu;
  currentPage: string;
  partnername: string = "";
  sktvnumber: string = "";
  avatar: string;
  infiniteScrollFn: any;
  bckText: string;
  menuopen: boolean = false;
  menuloading = signal<boolean>(true);
  ticking: boolean = false;
  isactivemenu: string = "";
  isBrowser: boolean = false;
  favoritesCount: number = 0;
  offerpackCount: number = 0;

  pathHistory: PathHistory;
  currentCustomer: Customer;
  currentCountryCode: any;

  cruiseActive: boolean = false;
  ferienhauserActive: boolean = false;
  camperActive: boolean = false;
  showTvInput: boolean = false;
  showChat: boolean = false;
  showTermin: boolean = false;
  showhReisekompass: boolean = false;
  showhLogin: boolean = false;
  showhDigbrater: boolean = false;

  destroyRef = inject(DestroyRef);

  logo: string = "";
  tooltiptext: string = "";
  ops: string = "";

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected guardService: AuthGuardService,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService,
    protected dialog: MatDialog,
    protected chatService: ChatService,
    protected hotelFilterService: HotelFiltersService,
    protected favoritesService: FavoritesService,
    protected offerpackService: OfferpackService,
    protected mediaObserver: BreakpointObserver,
    protected globalmenuService: GlobalmenuService,
    protected encservice: EncryptionService,
    @Inject(DOCUMENT) private document: any,
    protected mymenu: Menu,
    @Inject(PLATFORM_ID) protected platformId: any,
    @Optional() @Inject(MEDIA_TOKEN) private media_token: string
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.desktopTemplate = this.media_token !== "xs";
    this.mobile = this.media_token === "xs";
  }

  ngOnInit(): void {
    this.initMedia();
    this.initFavoriten();
    this.initOfferpack();
    this.initPartner();
  }

  async initPartner() {
    this.guardService.getPartner$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((obj) => {
        if (obj?.partnerid?.length > 0) {
          this.partner = obj;

          this.showhLogin = !this.partner.hideLogin;
          this.showTermin = !this.partner.hideTermin;
          this.showhReisekompass = !this.partner.hideReisekompass;
          this.showhDigbrater = !this.partner.hideDigbrater;

          this.tooltiptext =
            this.partner?.tel +
            "\nBeratung & Buchung täglich von \n\n" +
            (this.partner?.opening_period
              ? this.partner.opening_period
              : "08 - 23 Uhr");
          this.showChat = !this.partner.hideChat;
          // if (this.partner?.logo?.length > 0) {
          //     this.logo = 'https://' + this.document.location.hostname + '/logo/' + this.partner.partnerid + '/' + this.partner.logo;
          // }

          // if (obj?.firstname?.length > 0) {
          //     this.partnername = obj.firstname + ' ' + obj.lastname;
          // }
          // for (let i = 0; i < this.partner?.agenturen?.length; i++) {
          //     if (this.partner?.agenturen[i]?.aktiv) {
          //         this.ops += this.partner?.agenturen[i]?.code + ',';
          //     }
          // }
          // this.checkCruise();
          // this.checkCamper();
          // this.checkFerienhauser();
          this.getDefaultmenu();
          // this.initData();
        } else {
          this.partner = null;
          this.partnername = "";
        }
      });
  }

  openInput(): void {
    this.showTvInput = true;
  }

  async gotoCalendar() {
    this.router.navigate(["terminkalender"]);
  }

  openChat() {
    this.chatService.setOpenChat();
  }

  closeTvMenu(): void {
    this.showTvInput = false;
  }

  async initFavoriten() {
    this.favoritesService.favorites$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((count: number) => {
        this.favoritesCount = count;
        this.cdr.detectChanges();
      });
  }

  async initOfferpack() {
    this.offerpackService.offerpack$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((count: number) => {
        this.offerpackCount = count;
        this.cdr.detectChanges();
      });
  }

  async initMedia() {
    if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
      this.desktopTemplate = false;
    }
    if (this.mediaObserver.isMatched(Breakpoints.Small)) {
      this.desktopTemplate = false;
    }
    if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
      this.desktopTemplate = true;
    }
    if (this.mediaObserver.isMatched(Breakpoints.Large)) {
      this.desktopTemplate = true;
    }
    if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
      this.desktopTemplate = true;
    }
    this.cdr.detectChanges();
  }

  async checkCruise() {
    this.cruiseActive =
      this.partner?.xt?.active && this.partner?.xt?.ref?.length > 0;
  }

  async checkCamper() {
    this.camperActive =
      this.partner?.fti?.camper?.active &&
      this.partner?.fti?.camper?.benum?.length > 0;
  }

  async checkFerienhauser() {
    this.ferienhauserActive =
      this.partner.partnerid === "main" ||
      this.partner.partnerid === "reisen" ||
      (this.partner?.atraveo?.active && this.partner?.atraveo?.ref?.length > 0);
  }

  async getDefaultmenu() {
    if (this.defaultMenu) {
      this.defaultMenu.title = "Menü";
      this.mymenu.setMenus2(this.defaultMenu);
      this.mymenu.isDefault2.set(true);
      this.menuloading.set(false);
      this.cdr.detectChanges();
    }

    const target = {
      partnerid: this.partner.partnerid,
    };
    this.globalmenuService
      .requestnew(target, "getdefaultmenu")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        if (res?.isDefault) {
          res.title = "Menü";
          this.mymenu.setMenus2(res);
          this.mymenu.isDefault2.set(true);
          this.menuloading.set(false);
          this.cdr.detectChanges();
        }
      });
  }

  // async getglobalmenus() {
  //     const target = {
  //         partnerid: this.partner.partnerid
  //     }
  //     this.globalmenuService.request(target, 'getglobalmenus').pipe(
  //         takeUntilDestroyed(this.destroyRef)
  //     ).subscribe((res) => {
  //         // console.log(res)
  //         if (res?.active) {
  //             this.mymenu.setMenus(res);
  //         }
  //         this.menuloading.set(false);
  //         this.cdr.detectChanges();
  //     });
  // }

  async openMenu(ev) {
    ev && ev.stopPropagation();
    document.body.style.overflow = "hidden";
    this.curentMenu = [];
    this.openSubmenu = false;
    this.menuopen = true;
  }

  async closeMenu(ev) {
    ev.stopPropagation();
    document.body.style.overflow = "";
    this.menuopen = false;
  }

  async gobackMenu(ev) {
    ev.stopPropagation();
    this.mymenu.goBack();
  }

  async opensubmenu(ev) {
    this.mymenu.setCurrentMenu(ev);
  }

  async openLink(data) {
    new GoToFilter(this.encservice, this.router).goto(data, null);
    this.menuopen = false;
  }

  async goto(link) {
    this.isOpen = false;
    const url = this.router.createUrlTree([link]).toString();
    this.router.navigateByUrl(url);
  }

  async gotoCustomeraccount() {
    this.isOpen = false;
    const url = this.router.createUrlTree(["customeraccount"]).toString();
    this.router.navigateByUrl(url);
  }

  async initData() {
    this.authService.auth$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((customer: Customer) => {
        this.currentCustomer = customer;
        this.cdr.detectChanges();
      });
    this.pathHistory = {} as PathHistory;
  }

  // async gotoContent() {
  //     const url = this.router.createUrlTree(['contents']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotoAnfrage() {
  //     const url = this.router.createUrlTree(['anfrage']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotofavorites() {
  //     const url = this.router.createUrlTree(['favorites']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotoOfferpack() {
  //     const url = this.router.createUrlTree(['offerpack']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotohome() {
  //     this.isactivemenu = '';
  //     const url = this.router.createUrlTree(['']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotoback() {
  //     const url = this.router.createUrlTree(['']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotokreuzfahrten() {
  //     const url = this.router.createUrlTree(['kreuzfahrten']).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotoferienwohnung() {
  //     const url = this.router.createUrlTree(['ferienwohnung']).toString();
  //     this.router.navigateByUrl(url);
  // }

  async logout() {
    // my account
    this.authService
      .logout(this.partner?.partnerid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.offerpackService.resetOfferpackList();
        this.authService.resetCustomer(this.partner?.partnerid);
        const url = this.router.createUrlTree([""]).toString();
        this.router.navigateByUrl(url);
      });
  }

  // async gotSktv() {
  //     if (this.sktvnumber?.length > 0) {
  //         const navigationExtras: NavigationExtras = {
  //             queryParams: { params: this.encservice.encrypt({ extra: { orderId: this.sktvnumber } }) }
  //         };
  //         const url = this.router.createUrlTree(['sktv'], navigationExtras).toString();
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('visibility', 'hidden');
  //         link.click();
  //     }
  // }

  // async gotoPath(path1, path2?) {
  //     this.isactivemenu = path2?.length > 0 ? path2 : path1;
  //     this.hotelFilterService.setonlyDefault();
  //     const url = this.router.createUrlTree([path1]).toString();
  //     this.router.navigateByUrl(url);
  // }

  // async gotoFerienhauser() {
  //     this.isactivemenu = 'ferienhauser';
  //     this.hotelFilterService.setonlyDefault();
  //     if (this.partner.partnerid === 'main' || this.partner.partnerid === 'reisen') {
  //         const url = this.router.createUrlTree(['ferienhauser']).toString();
  //         this.router.navigateByUrl(url);
  //     } else if (this.ferienhauserActive) {
  //         const url = this.router.createUrlTree(['ferienwohnung']).toString();
  //         this.router.navigateByUrl(url);
  //     }
  // }

  async gotoPartner() {
    let target = {} as MatDialogConfig;
    this.currentCustomer = {} as Customer;
    this.currentCustomer.partnerid = this.guardService.getPartnerId();
    if (this.desktopTemplate) {
      target = {
        width: "400px",
        panelClass: "customModal",
        maxHeight: "100vh",
        disableClose: true,
        data: {
          password: this.currentCustomer.password,
          partnerid: this.currentCustomer.partnerid,
          email: this.currentCustomer.email,
          modeLogin: true,
        },
      };
    } else {
      target = {
        width: "100%",
        height: "100vh",
        maxWidth: "100%",
        panelClass: "customModal",
        disableClose: true,
        data: {
          firstname: this.currentCustomer.firstname,
          lastname: this.currentCustomer.lastname,
          password: this.currentCustomer.password,
          partnerid: this.currentCustomer.partnerid,
          email: this.currentCustomer.email,
          domainname: this.partner.partnerdomain,
          modeLogin: true,
        },
      };
    }
    const diagRef = this.dialog.open(PartnerloginComponent, target);
    diagRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result?.token?.length > 0) {
          this.currentCustomer = result;
          this.authService.setAuth(this.currentCustomer);
        }
      });
  }
}
